import React, { Component, Fragment } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
} from "reactstrap";
import NumberFormat from 'react-number-format';

export default class NumberCtr extends Component {
  render() {
    return (
      <div className="animated fadeIn numberctr">
        <Button tabIndex="-1" size="sm" color="secondary" onClick={(e) => this.props.downClick(e)}>
          <i className={`fa fa-minus`}></i>
        </Button>
        <NumberFormat
          name={this.props.name}
          value={this.props.value}
          tabIndex={this.props.tabIndex}
          defaultValue={this.props.defaultValue}
          thousandSeparator={this.props.thousandSeparator}
          decimalSeparator={this.props.decimalSeparator}
          decimalScale={this.props.decimalScale}
          type={this.props.type}
          allowEmptyFormatting={this.props.allowEmptyFormatting}
          className={this.props.className}
          onClick={this.props.onClick}
          onValueChange={this.props.onValueChange}
          onKeyDown={e => this.props.onKeyDown(e)}
        />
        <Button tabIndex="-1" size="sm" color="primary" onClick={(e) => this.props.upClick(e)}>
          <i className={`fa fa-plus`}></i>
        </Button>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Order/_NumberCtr.js